import Standard from '@/store/models/Standard'
import { loadStandardsList } from '@/api/standard'

let standardModel = new Standard()

export default {

  namespaced: true,

  state: {
    standard: standardModel,
    standards_list: []
  },

  mutations: {
    ...standardModel.mutations(),
    setList: (state, payload) => state.standards_list = payload
  },

  actions: {
    loadStandardsList: ({ commit }) => new Promise((resolve, reject) => {
      loadStandardsList(({ data }) => {
        commit('setList', data)
        resolve()
      }, reject)
    })
  },

  getters: {
    standard: state => state.standard,
    standardsList: state => state.standards_list,
  }

}